import { render, staticRenderFns } from "./ModalEditMemberApprove.vue?vue&type=template&id=5e832c10&"
import script from "./ModalEditMemberApprove.vue?vue&type=script&lang=js&"
export * from "./ModalEditMemberApprove.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditMemberApprove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports